import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '~app/services/translation-loader.service';
import { MaterialModule } from '~app/shared/material.module';
import { FormStateComponent } from '../form-state/form-state.component';
import { locale as english } from '../i18n/en';
import { locale as french } from '../i18n/fr';
import { FormStateStoreModule } from './store/form-state-store.module';

@NgModule({
  declarations: [FormStateComponent],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule.forChild(),
    FormStateStoreModule
  ],
  exports: [FormStateComponent]
})
export class FormStateModule {
  constructor(translationLoader: FuseTranslationLoaderService) {
    translationLoader.loadTranslations(english, french);
  }
}
